var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"el-icon-back",on:{"click":_vm.goBack}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }